export const c_list_ul_ListStyle = {
  "name": "--pf-c-list--ul--ListStyle",
  "value": "disc outside",
  "var": "var(--pf-c-list--ul--ListStyle)"
};
export default c_list_ul_ListStyle;